
export function focusTrap(...elements) {
	
	const selector = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
	let groups
	let previousFocus

	function enter() {	
		previousFocus = document.activeElement
		groups = elements
			.map((el, i) => createGroup(el, i))
			.filter(Boolean)
		groups[0].first.focus()
	}

	function createGroup(el, index) {
		const focusable = []
		if (el.matches(selector)) focusable.push(el)
		focusable.push(...el.querySelectorAll(selector))
		el.addEventListener('keydown', onKeydown)
		if (!focusable.length) return
		return { 
			el: el,
			first: focusable[0], 
			last: focusable[focusable.length - 1],
			index: index
		}
	}

	function exit() {
		previousFocus.focus()
		elements.map(el => el.removeEventListener('keydown', onKeydown))
	}

	function onKeydown(e) {	
		const trapped = (e.key === "Tab" && document.activeElement === e.target)
		const group = groups.find(el => el.el === e.currentTarget)
		
		if (!trapped || !group) return
		const { first, last, index } = group
		const lastInPrevious = (groups[index - 1] || groups[groups.length - 1]).last
		const firstInNext = (groups[index + 1] || groups[0]).first

		if (first === e.target && e.shiftKey && lastInPrevious) {
			lastInPrevious.focus()
			e.preventDefault()
		} else if (last === e.target && !e.shiftKey && firstInNext) {
			firstInNext.focus()
			e.preventDefault()
		}
	}

	return { 
		enter,
		exit
	}
}